import { useQuery } from '@tanstack/react-query';
import { fetchEnrichedCustomerData } from '@Services/init/partnerWelcome.api.ts';

export const useFetchCustomerData = () =>
  useQuery({
    queryFn: fetchEnrichedCustomerData,
    queryKey: ['fetchEnrichedCustomerData'],
    enabled: false,
  });
